const Password = value => {
    if (typeof value === 'undefined' || value === null) return undefined;
    return   'Password do not match'
} 
  
  export default Password;